import React, {useContext, useState} from 'react';
import PaypalButton from '../../api/paypal/button';
import paymentStyle from './style';
import {GlobalContext} from '../../utilities/GlobalContext';
import Workout from '../../components/workoutsDisplay/singleWorkout';
import CourseDescription from '../../components/courseDescription';
import Banner from '../../components/banner';
import WarningBlock from '../../components/highlightedBlock';
import InfoBlock from '../../components/infoBlock';

export default function BuyCourse({displayName, meta, price, thumbnail, subTitle, demoContent}) {
	let {apiName} = meta;
	let [seeAll, setSeeAll] = useState(false);
	let style = paymentStyle();
	let user = useContext(GlobalContext).user;

	return (
		<div style={style.buyCourseContainer()}>
			<CourseDescription mt={true} title={demoContent.titles[0]} texts={['Please note this is demo content.']} />
			<Banner
				mt={true}
				bgImage={demoContent.bannerImage}
				title={'There is always room for improvement.'}
				alignment={demoContent.bannerTextPosition}
			/>
			<CourseDescription mt={true} title={demoContent.titles[1]} texts={demoContent.descriptions} />

			<WarningBlock
				texts={[
					'The programs that are provided are 8-12 weeks long and require repetition and consistency. Please look to the “Arsenal” for different exercises to replace then perform.',
				]}
				mt={true}
			/>
			{demoContent.warnings ? <WarningBlock texts={demoContent.warnings} mt={true} /> : <></>}
			<InfoBlock
				texts={[
					'Please email brugmethod@gmail.com to get updated programs, exercises, custom personal workout plans, or nutrition advising.',
				]}
				mt={true}
			/>
			{demoContent.infos ? <InfoBlock texts={demoContent.infos} mt={true} /> : <></>}

			<div style={style.topContentContainer()} className='mt-5'>
				<h1 style={style.courseNameTitle()}>{displayName}</h1>
				<p>{`Purchase the ${displayName} course and it will be added to your ${user.email} account`}</p>
				<hr />
			</div>
			<div style={style.purchaseAreaContainer(seeAll)}>
				<Workout
					name={displayName}
					subtext={subTitle}
					routeName={apiName}
					thumbnail={thumbnail}
					addonClasses={style.workoutContainerClasses(seeAll)}
					addonStyle={style.workoutContainer(seeAll)}
					showLinks={false}
				/>
				<div style={style.purchaseTextContainer(seeAll)} className={style.purchaseTextContainerClasses(seeAll)}>
					<p style={style.priceText(seeAll)}>{`Price: $${price}`}</p>
					{demoContent && demoContent.descriptions ? (
						demoContent.descriptions.map((description, i) => {
							return (
								<p
									key={i}
									style={style.descriptionText(seeAll)}
									className={style.descriptionTextClass(seeAll)}
								>
									{description}
								</p>
							);
						})
					) : (
						<></>
					)}
					<button onClick={toggleSeeAll} style={style.seeMoreDescriptionButton()}>
						{seeAll ? `Show less` : `Show more`}
					</button>
				</div>
				<div className='col-12 col-sm-4'>
					<p style={style.payHereText()}>Pay here</p>
					<div className='mt-3'>
						<PaypalButton courseName={apiName} price={price} />
					</div>
				</div>
			</div>
		</div>
	);

	function toggleSeeAll() {
		setSeeAll(!seeAll);
	}
}
